import UCart from "../features/Cart/Cart";

function CartPage() {
    return <div>
        <UCart></UCart>
    </div>;
}

export default CartPage;